export const EmptyDocumentState = () => (
  <div className="tw-border-t tw-border-border tw-pt-4 tw-py-8 tw-text-center">
    <p className="tw-text-sm tw-text-muted-foreground">No documents uploaded yet.</p>
  </div>
);
